// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 5px;
  width: 300px;
  font-weight: 600;
}

.clearFilter {
  background-color: #f0f2f5;
  border: 1px solid #dadee2;
  color: #495057;
  font-size: 0.875rem; /* Slightly increase the font size for better readability */
  padding: 6px 12px;
  border-radius: 8px; /* Slightly rounded for a smoother look */
  font-weight: 500;
  text-align: center;
  transition: background-color 0.3s ease, box-shadow 0.3s ease, transform 0.2s ease; /* Added transition for scaling effect */
  cursor: pointer; /* Indicating it's clickable */
}

.clearFilter:hover {
  background-color: #e2e6ea;
  color: #212529;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12); /* Soft shadow for better hover effect */
  transform: scale(1.05); /* Slight scaling effect to make it feel interactive */
}

.clearFilter:active {
  background-color: #dae0e5; /* Darker background on active click */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15); /* Slightly deeper shadow when clicked */
  transform: scale(0.98); /* Slight shrink when button is pressed */
}

`, "",{"version":3,"sources":["webpack://./src/containers/MiscSettlement/MiscSettlement.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,mBAAmB,EAAE,2DAA2D;EAChF,iBAAiB;EACjB,kBAAkB,EAAE,yCAAyC;EAC7D,gBAAgB;EAChB,kBAAkB;EAClB,iFAAiF,EAAE,wCAAwC;EAC3H,eAAe,EAAE,8BAA8B;AACjD;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yCAAyC,EAAE,wCAAwC;EACnF,sBAAsB,EAAE,sDAAsD;AAChF;;AAEA;EACE,yBAAyB,EAAE,sCAAsC;EACjE,yCAAyC,EAAE,wCAAwC;EACnF,sBAAsB,EAAE,yCAAyC;AACnE","sourcesContent":[".modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modal-content {\n  background: white;\n  padding: 20px;\n  border-radius: 5px;\n  width: 300px;\n  font-weight: 600;\n}\n\n.clearFilter {\n  background-color: #f0f2f5;\n  border: 1px solid #dadee2;\n  color: #495057;\n  font-size: 0.875rem; /* Slightly increase the font size for better readability */\n  padding: 6px 12px;\n  border-radius: 8px; /* Slightly rounded for a smoother look */\n  font-weight: 500;\n  text-align: center;\n  transition: background-color 0.3s ease, box-shadow 0.3s ease, transform 0.2s ease; /* Added transition for scaling effect */\n  cursor: pointer; /* Indicating it's clickable */\n}\n\n.clearFilter:hover {\n  background-color: #e2e6ea;\n  color: #212529;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12); /* Soft shadow for better hover effect */\n  transform: scale(1.05); /* Slight scaling effect to make it feel interactive */\n}\n\n.clearFilter:active {\n  background-color: #dae0e5; /* Darker background on active click */\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15); /* Slightly deeper shadow when clicked */\n  transform: scale(0.98); /* Slight shrink when button is pressed */\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
